import { EditorState } from "@common/Common";
import { ValidationError } from "@common/types";

export class SurveyEditorDialogViewModel
{
    editorState: EditorState = EditorState.Closed;
    editorTitle: string = null;

    surveyId: number = null;
    surveyName: string | null = null;
    surveyDescription: string | null = null;
    responseDueDate: string | null = null;
    nameError: string | null = null;
    get opened(): boolean { return this.editorState !== EditorState.Closed; }

    showCreator(surveyName: string)
    {
        this.surveyId = 0;
        this.surveyName = surveyName;
        this.surveyDescription = null;
        this.responseDueDate = null;

        this.editorTitle = "Create opinion panel"
        this.editorState = EditorState.Creator;
    }

    showEditor(surveyId: number, surveyName: string, surveyDescription: string, responseDueDate: string | null)
    {
        this.surveyId = surveyId;
        this.surveyName = surveyName;
        this.surveyDescription = surveyDescription;
        this.responseDueDate = responseDueDate;

        this.editorTitle = `Edit panel: ${surveyName}`
        this.editorState = EditorState.Editor;
    }

    close()
    {
        this.editorState = EditorState.Closed;
    }

    displayValidationErrors(errors: ValidationError[])
    {
        for (const error of errors)
        {
            if (error.Context == "Name")
            {
                this.nameError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }

}